// import React, { useEffect, useState } from "react";
// import { FaBars } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { AuthAPI } from "../api/AuthAPI";
// import DashboardLayout from "../layouts/DashboardLayout";

// export default function PurchaseHistory() {
//   const navigate = useNavigate();

//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [page, setPage] = useState(1);
//   const [pagination, setPagination] = useState(null);

//   useEffect(() => {
//     fetchOrders();
//   }, [page]);

//   async function fetchOrders() {
//     try {
//       setLoading(true);

//       const res = await AuthAPI.getallpurchase({
//         page,
//         limit: 10,
//       });

//       setOrders(res?.data?.data || []);

//       setPagination(res?.data?.settings || null);
//     } catch (err) {
//       console.error(err);
//       setOrders([]);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const goNextPage = () => {
//     if (!pagination || page >= pagination.total_pages) return;

//     setPage((p) => p + 1);
//   };

//   const goPrevPage = () => {
//     if (page <= 1) return;
//     setPage((p) => p - 1);
//   };

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   const Badge = ({ text, green }) => (
//     <span
//       className={`text-xs px-3 py-1 rounded-full font-medium ${
//         green ? "bg-green-100 text-green-700" : "bg-blue-100 text-blue-700"
//       }`}
//     >
//       {text}
//     </span>
//   );

//   return (
//     <DashboardLayout>
//       <div className="bg-white rounded-2xl border shadow-sm p-6 mt-6 md:mt-0">
//         <h2 className="text-2xl font-bold mb-6">Purchase History</h2>

//         {loading && (
//           <div className="space-y-4">
//             {[1, 2, 3].map((i) => (
//               <div
//                 key={i}
//                 className="h-28 rounded-xl bg-gray-100 animate-pulse"
//               />
//             ))}
//           </div>
//         )}

//         {!loading && orders.length === 0 && (
//           <div className="text-center py-20 text-gray-500">No orders found</div>
//         )}

//         {/* mobile */}
//         {!loading && (
//           <div className="grid grid-cols-1 gap-5 lg:hidden">
//             {orders.map((order) => {
//               const first = order.items?.[0];

//               const image = first?.product?.images?.[0]?.image;

//               return (
//                 <div
//                   key={order.id}
//                   onClick={() =>
//                     navigate(`/dashboard/purchase-history/order/${order.id}`)
//                   }
//                   className="border rounded-2xl p-4 shadow-sm cursor-pointer hover:shadow-md hover:border-blue-300 transition"
//                 >
//                   <div className="flex gap-4">
//                     <img
//                       src={image || "/placeholder.png"}
//                       alt=""
//                       className="w-24 h-24 rounded-xl object-cover border"
//                     />

//                     <div className="flex-1">
//                       <h3 className="font-semibold text-gray-900 line-clamp-2">
//                         {first?.product?.name}
//                       </h3>

//                       {order.items.length > 1 && (
//                         <p className="text-xs text-gray-500 mt-1">
//                           +{order.items.length - 1} more items
//                         </p>
//                       )}

//                       <p className="text-sm mt-2 text-gray-500">
//                         Order #{order.id}
//                       </p>

//                       <p className="text-sm text-gray-500">
//                         {formatDate(order.createdAt)}
//                       </p>

//                       <div className="flex flex-wrap gap-2 mt-3">
//                         <Badge text={order.payment_status} green />
//                         <Badge text={order.order_status} />
//                       </div>

//                       <div className="flex items-center justify-between mt-4">
//                         <div className="font-bold text-lg">
//                           ₹{order.payable_amount}
//                         </div>

//                         <div className="text-blue-600 text-sm font-medium">
//                           View Details →
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}

//         {/* desktop */}
//         {!loading && (
//           <div className="hidden lg:block overflow-x-auto">
//             <table className="w-full">
//               <thead className="border-b text-sm text-gray-500">
//                 <tr>
//                   <th className="py-4 text-left">Order</th>
//                   <th className="text-left">Product</th>
//                   <th className="text-left">Date</th>
//                   <th className="text-left">Amount</th>
//                   <th className="text-left">Status</th>
//                   <th className="text-left">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {orders.map((order) => {
//                   const first = order.items?.[0];

//                   return (
//                     <tr
//                       key={order.id}
//                       onClick={() =>
//                         navigate(
//                           `/dashboard/purchase-history/order/${order.id}`,
//                         )
//                       }
//                       className="border-b hover:bg-gray-50border rounded-2xl p-4 shadow-sm cursor-pointer hover:shadow-md hover:border-blue-300 transitio"
//                     >
//                       <td className="py-5">#{order.id}</td>

//                       <td className="py-5">
//                         <div className="flex items-center gap-3">
//                           <img
//                             src={
//                               first?.product?.images?.[0]?.image ||
//                               "/placeholder.png"
//                             }
//                             className="w-14 h-14 rounded-lg object-cover"
//                             alt=""
//                           />

//                           <div>
//                             <div className="font-medium">
//                               {first?.product?.name}
//                             </div>

//                             {order.items.length > 1 && (
//                               <div className="text-xs text-gray-500">
//                                 +{order.items.length - 1} more
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </td>

//                       <td>{formatDate(order.createdAt)}</td>

//                       <td>₹{order.payable_amount}</td>

//                       <td>
//                         <div className="flex flex-col gap-2">
//                           <Badge text={order.payment_status} green />
//                           <Badge text={order.order_status} />
//                         </div>
//                       </td>

//                       <td>
//                         <button
//                           onClick={() =>
//                             navigate(
//                               `/dashboard/purchase-history/order/${order.id}`,
//                             )
//                           }
//                           className="w-10 h-10 rounded-full bg-blue-100 hover:bg-blue-200 flex items-center justify-center"
//                         >
//                           <FaBars />
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {pagination && pagination.total_pages > 1 && (
//           <div className="flex justify-center items-center gap-5 mt-8">
//             <button
//               onClick={goPrevPage}
//               disabled={page <= 1}
//               className={`px-5 py-2 rounded-lg border ${
//                 page > 1
//                   ? "hover:bg-gray-50"
//                   : "bg-gray-100 text-gray-400 cursor-not-allowed"
//               }`}
//             >
//               Prev
//             </button>

//             <span className="font-medium">
//               Page {page} of {pagination.total_pages}
//             </span>

//             <button
//               onClick={goNextPage}
//               disabled={page >= pagination.total_pages}
//               className={`px-5 py-2 rounded-lg border ${
//                 page < pagination.total_pages
//                   ? "hover:bg-gray-50"
//                   : "bg-gray-100 text-gray-400 cursor-not-allowed"
//               }`}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// }













import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthAPI } from "../api/AuthAPI";
import DashboardLayout from "../layouts/DashboardLayout";

export default function PurchaseHistory() {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, [page]);

  async function fetchOrders() {
    try {
      setLoading(true);

      const res = await AuthAPI.getallpurchase({
        page,
        limit: 6,
      });

      // API returns orders directly under `data`, not `data.data`
      setOrders(res?.data?.data || []);
      setPagination(res?.data?.settings || null);
    } catch (err) {
      console.error(err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }

  const goNextPage = () => {
    if (!pagination || page >= pagination.total_pages) return;
    setPage((p) => p + 1);
  };

  const goPrevPage = () => {
    if (page <= 1) return;
    setPage((p) => p - 1);
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

const statusStyles = (status) => {
  const s = (status || "").toLowerCase();

  switch (s) {
    case "pending":
      return "bg-violet-50 text-violet-700 ring-1 ring-violet-200";
    case "confirmed":
      return "bg-pink-50 text-pink-700 ring-1 ring-pink-200";
    case "processing":
      return "bg-amber-50 text-amber-700 ring-1 ring-amber-200";
    case "shipped":
      return "bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200";
    case "delivered":
      return "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200";
    case "cancelled":
      return "bg-red-50 text-red-700 ring-1 ring-red-200";
    case "paid":
      return "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200";
    case "failed":
      return "bg-red-50 text-red-700 ring-1 ring-red-200";
    default:
      return "bg-gray-50 text-gray-600 ring-1 ring-gray-200";
  }
};

  const Badge = ({ text }) => (
    <span
      className={`text-xs px-3 py-1 rounded-full font-medium capitalize ${statusStyles(
        text,
      )}`}
    >
      {text}
    </span>
  );

  return (
    <DashboardLayout>
      <div className="bg-white rounded-2xl border shadow-sm p-6 mt-12 md:mt-0">
        <h2 className="text-2xl font-bold mb-6">My Orders</h2>

        {loading && (
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="h-24 rounded-xl bg-gray-100 animate-pulse"
              />
            ))}
          </div>
        )}

        {!loading && orders.length === 0 && (
          <div className="text-center py-20 text-gray-500">
            No orders found
          </div>
        )}

        {/* order cards (works for mobile + desktop) */}
        {!loading && orders.length > 0 && (
          <div className="grid grid-cols-1 gap-4">
            {orders.map((order) => (
              <div
                key={order.id}
                onClick={() =>
                  navigate(`/dashboard/purchase-history/order/${order.id}`)
                }
                className="group border rounded-2xl p-5 cursor-pointer transition hover:shadow-md hover:border-blue-300"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-4 min-w-0">
                    <div className="w-14 h-14 shrink-0 rounded-xl bg-gray-100 border flex items-center justify-center text-gray-400 text-xs font-medium">
                      {order.total_items || order.total_qty || "-"}x
                    </div>

                    <div className="min-w-0">
                      <h3 className="font-semibold text-gray-900 truncate">
                        #{order.order_number}
                      </h3>
                      <p className="text-sm text-gray-500 mt-0.5">
                        {formatDate(order.createdAt)} ·{" "}
                        {order.total_items ?? order.total_qty ?? 0} item
                        {(order.total_items ?? order.total_qty ?? 0) !== 1
                          ? "s"
                          : ""}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-end gap-2 shrink-0">
                    <div className="font-bold text-lg">
                      ₹{order.grand_total}
                    </div>
                    <Badge text={order.order_status} />
                  </div>
                </div>

                <div className="flex flex-wrap items-center justify-between gap-4 mt-4">
                  <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-sm text-gray-500">
                    <span>
                      <span className="text-gray-400">Payment:</span>{" "}
                      <span className="capitalize font-medium text-gray-700">
                        {order.payment_method}
                      </span>
                    </span>

                    <span>
                      <span className="text-gray-400">Status:</span>{" "}
                      <Badge text={order.payment_status} />
                    </span>

                    <span>
                      <span className="text-gray-400">Deliver to:</span>{" "}
                      <span className="font-medium text-gray-700">
                        {order.shipping_address?.city || "-"}
                      </span>
                    </span>

                    <span>
                      <span className="text-gray-400">Customer:</span>{" "}
                      <span className="font-medium text-gray-700">
                        {order.customer_name}
                      </span>
                    </span>
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        `/dashboard/purchase-history/order/${order.id}`,
                      );
                    }}
                    className="flex items-center gap-2 text-blue-600 text-sm font-medium hover:underline shrink-0"
                  >
                    View Details <FaArrowRight className="text-xs" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

      
      </div>
        {/* {pagination && pagination.total_pages > 1 && (
          <div className="flex justify-center items-center gap-5 mt-8">
            <button
              onClick={goPrevPage}
              disabled={page <= 1}
              className={`px-3 py-1.5 rounded-lg border ${
                page > 1
                  ? "hover:bg-blue-500"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed"
              }`}
            >
              Prev
            </button>

            <span className="font-medium">
              Page {page} 
            </span>

            <button
              onClick={goNextPage}
              disabled={page >= pagination.total_pages}
              className={`px-3 py-1.5 rounded-lg border ${
                page < pagination.total_pages
                  ? "hover:bg-blue-500"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed"
              }`}
            >
              Next
            </button>
          </div>
        )} */}
        {pagination && pagination.total_pages > 1 && (
  <div className="flex justify-center items-center gap-5 mt-8">
    <button
      onClick={goPrevPage}
      disabled={page <= 1}
      className={`px-3 py-1.5 rounded-lg border font-medium transition ${
        page > 1
          ? "border-blue-500 text-blue-600 bg-blue-50 hover:bg-blue-500 hover:text-white"
          : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
      }`}
    >
      Prev
    </button>

    <span className="font-medium">Page {page}</span>

    <button
      onClick={goNextPage}
      disabled={page >= pagination.total_pages}
      className={`px-3 py-1.5 rounded-lg border font-medium transition ${
        page < pagination.total_pages
          ? "border-blue-500 text-blue-600 bg-blue-50 hover:bg-blue-500 hover:text-white"
          : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
      }`}
    >
      Next
    </button>
  </div>
)}
    </DashboardLayout>
  );
}